module.exports = __webpack_public_path__ + "static/media/4_arrow.5d4ff79d.svg";